<div class="one3d-scrollable-wrapper-custom">
   <div class="one3d-privacy-popup-wrapper">
      <div class="one3d-close-popup-fixed">
         <h2 class="one3d-privacy-popup-title" translate>
            PRIVACY_POLICY.PRIVACY_POLICY
         </h2>
         <ion-icon (click)="closeModal()" name="close"></ion-icon>
      </div>

      <div class="one3d-privacy-popup-para">

         <div class="one3d-privacy-popup-para-row">
            <p><b>Privacy Policy</b></p>
            <p>FCA AUSTRALIA PTY LTD trading as FCA Australia (Chrysler, Jeep, Dodge, Fiat, Alfa Romeo and Mopar)</p>
         </div>

         <div class="one3d-privacy-popup-para-row">
            <p>Version Date: September 2016</p>
         </div>

         <div class="one3d-privacy-popup-para-row">
            <p><b>Introduction</b></p>
            <p>Welcome to this FCA Australia Pty Ltd (ACN 125 956 505) (“FCAA”) website. FCAA is a member of the
               worldwide Fiat Chrysler Group (“FCAG”), a group of companies comprising Chrysler Group LLC and Fiat Group
               Automobiles S.p.A. and all their associated companies.</p>
         </div>

         <div class="one3d-privacy-popup-para-row">
            <p><b>Privacy Policy</b></p>
            <p>FCAA respects your privacy and takes seriously its obligations to comply with the Australian Privacy
               Principles (“APPs”) contained in the Privacy Act 1988 (Cth) (as amended from time to time) (“Privacy
               Act”).</p>
            <p>“Personal Information” includes information that alone or when in combination with other information may
               be used to readily identify, contact, or locate you (e.g., name, address, telephone number, email
               address, and location).</p>
            <p>We know that you care about how your Personal Information is collected, used, and shared and we want to
               help you make knowledgeable choices about the information you provide to us. This Privacy Policy
               (“Privacy Policy”) explains and summarises how FCAA collects, uses, and protects your information,
               including the Personal Information that you may provide to us or that we may collect from you as you
               interact with us.</p>
            <p>This Privacy Policy applies when FCAA collects data from customers and guests, including through FCAA
               controlled websites or applications, and FCAA controlled applications accessed and/or used on a mobile,
               handheld or other wirelessly connected device (a “Website” or “Application”). Any Personal Information
               you provide is voluntary.</p>
            <p>By disclosing your Personal Information to us or using our Websites or Applications, you consent to its
               collection, use and distribution by FCAA in a manner that is consistent with the Privacy Act and any
               other applicable data protection laws and this Privacy Policy (which is expressly incorporated into any
               applicable Website or Application terms of use).</p>
            <p>We will update this Privacy Policy from time to time, so please check back with us periodically, as your
               continued use of our Websites or Applications means you acknowledge, agree to and consent to those
               changes.</p>
         </div>

         <div class="one3d-privacy-popup-para-row">
            <p><b>How we collect your information</b></p>
            <p>In the course of providing services to you, FCAA collects your information in a number of ways.</p>

            <p>For example, we collect information when you:</p>

            <ul>
               <li>use a Website or Application to make an enquiry about our products and services such as when you
                  request to be sent information or for purposes that are made clear on the page on which the
                  information is collected;</li>
               <li>apply for employment with us through the application process, including through third parties such as
                  your referees and previous employers; <br></li>
               <li>enter our Website our third party Internet Host provider records your server address; domain name,
                  the date and time of your visit and the pages viewed and we may also obtain information about you from
                  Google analytics;</li>
               <li>enter into written agreements with us, our dealers, agents or third party service providers;</li>
               <li>purchase a vehicle or service a vehicle and become a customer;</li>
               <li>supply goods or services to us; </li>
               <li>answer a survey or respond to requests from a market research agencies engaged by us;</li>
               <li>fill in a competition form; </li>
               <li>post a comment on our website, send us an email or make a telephone enquiry;</li>
               <li>ask to be placed on a mailing list; </li>
               <li>provide your information to a third party that we supply or provide services to, such as our FCAA
                  related body corporates, dealers and distributors, contractors and regulatory authorities.</li>
            </ul>

            <p>FCAA may also collect information about you that is publicly available from outside sources including
               information from telephone directories, the electoral roll, other websites, device ID information from
               mobile applications or advertisements or purchase e-mail or similar lists from third parties for
               advertising and marketing purposes. </p>
         </div>

         <div class="one3d-privacy-popup-para-row">
            <p><b>Types of information we collect</b></p>
            <p>The types of information we collect from you will vary depending on the purpose for which it is collected
               by FCAA, but may include:</p>
            <ul>
               <li>Name, email address, telephone and fax numbers and delivery details;</li>
               <li>Drivers' Licence details;</li>
               <li>Age;</li>
               <li>Gender;</li>
               <li>Occupation;</li>
               <li>ABN;</li>
               <li>Your car registration details, VIN and number plate;</li>
               <li>Your car's repairs and service history;</li>
               <li>IP Address;</li>
               <li>Location data;</li>
               <li>Device type (iPhone, laptop etc);</li>
               <li>Domain name;</li>
               <li>Web browser, Safari, Firefox;</li>
               <li>Date and time of access to the website and which website you came from;</li>
               <li>Content of emails; and</li>
               <li>Information you post on your webpage.</li>
            </ul>
            <p>Location data and other information that you provide to us may be accessed in connection with your use of
               a Website or Application. Your use of, and our ability to offer location based functionality is then
               enabled through our use and disclosure to third parties of location data and associated information. When
               you interact with us or purchase a FCAA product through a Website or an Application (for example, to get
               a quote or locate a dealer) you will be asked for information needed to complete your request. The
               Personal Information you provide is used, for example, to process your transactions, to create and share
               reports about these transactions, or to provide related customer service. When you shop online or buy
               direct from one of our online stores, these purchase transactions may be conducted through FCAA vendors
               and suppliers. </p>
         </div>

         <div class="one3d-privacy-popup-para-row">
            <p><b>Customer's Sensitive Information</b></p>
            <p>FCCA does not generally require customers to provide Sensitive Information (as defined in the Privacy
               Act) such as race, religious beliefs, sexual orientation or health information etc.</p>
            <p>Occasionally a customer will advise a disability or a trade or professional association to which he or
               she belongs to that is sensitive information, but we do not actively seek this information. If you
               disclose sensitive information to us you consent to our collecting, using and disclosing this sensitive
               information for the purpose for which you disclosed it to us and as permitted under the Privacy Act and
               other relevant laws.</p>
         </div>

         <div class="one3d-privacy-popup-para-row">
            <p><b>Contractor to FCAA</b></p>
            <p>If you are a contractor to FCAA, we may collect information relating to your engagement by FCAA in
               relation to your qualifications, training records and logs, references, length of engagement, resume, pay
               rate, salary, bank account details and ABN.</p>
         </div>

         <div class="one3d-privacy-popup-para-row">
            <p><b>Employment Applications</b></p>
            <p>If you apply for a job with FCAA, we will use the Personal Information you provide to assess your
               application. We may disclose your Personal Information to third party service providers to assist with
               the assessment which may include screening, aptitude tests, human resources management purposes such as
               background checks and discussing your application with referees, medical tests and health assessments.
            </p>
            <p>During this process we may collect sensitive Personal Information which is provided directly by you. The
               sensitive information that may be collected during the employment process if given voluntarily by may
               include: race, religion, professional or trade association memberships, health or criminal records. As
               part of the application, we may ask you to undergo a medical assessment and/or complete a health
               questionnaire. If this occurs we may disclose your Personal Information to a third party service provider
               for the purposes of completing a health/medical assessment. If a health/medical assessment is required,
               we will ask for your consent again at the time we need to make the disclosure. If you are unable to
               consent to these disclosures we will not be able to consider your application for employment. </p>
            <p>FCAA does not collect and/or process any Personal or Sensitive Information against the express wishes of
               an individual, unless FCAA is required by law to do so. </p>
         </div>

         <div class="one3d-privacy-popup-para-row">
            <p><b>Anonymity and Pseudonyms</b></p>
            <p>You have the right to remain anonymous or use a pseudonym when entering into transactions with FCAA,
               unless such anonymity or use of a pseudonym would be considered unlawful or impracticable. Please let us
               know if you wish to deal with us anonymously or by a pseudonym, and where possible, we will accommodate
               this request.</p>
            <p>However, failing to provide your Personal Information may in some instances make it impractical or
               impossible to provide you with our products or services. For example, if we are unable to collect your
               Personal Information at the time of a new vehicle purchase, we would not be able to notify you of a
               product recall affecting your vehicle and would not be able to register the transfer of ownership with
               the relevant licensing authority.</p>
         </div>

         <div class="one3d-privacy-popup-para-row">
            <p><b>Non-personal information, cookies and related information collection</b></p>
            <p>FCAA or others acting on our behalf may use cookies, pixel tags, web beacons or other similar
               technologies in connection with the operation of our Websites or Applications. These technologies may
               collect and store non-Personal Information. We utilize these technologies to research and understand how
               our Websites and Applications are used, to develop our products and services, to personalize your online
               experience with FCAA to assist us with targeting our advertising and marketing. We may share data
               collected from you on our Websites with our third party vendors or suppliers to advertise or market to
               you on other sites as you browse the web. At the end of your visit, session cookies used by FCAA are
               removed. However, in some instances some FCAA cookies may persist. For example, to customize your
               experience we may require registration to recognize your computer and enable you to log-in without having
               to enter your password. It is possible that Cookies placed by FCAA or its vendors or suppliers (as
               applicable) in connection with the operation of the Website or Application may remain stored on your
               computer until you remove them.</p>
            <p>Our service providers or vendors may also use cookies and related technologies in order to personalize
               your experiences and adapt a particular FCAG Website or Application's functionality to your preferences
               and for purposes such as those listed above. If you are visiting a URL other than the FCAG websites
               (www.fiatchrysler.com.au , www.jeep.com.au, www.chrysler.com.au, www.fiat.com.au , www.alfaromeo.com.au,
               www.dodge.com.au, www.mopar.com.au and www.drivesrt.com.au) or other FCAA or FCAG Websites or
               Applications, you should carefully review the privacy policies of those web sites or applications.</p>
            <p>You may set your browser to notify you when you receive a cookie or to refuse receiving it. You should be
               aware that this may interfere with or make you unable to use certain functionality on websites using
               cookies and you may not be able to take full advantage of the services available to you on our website.
               For example, many websites will ask your permission to use a cookie that will enable you to automatically
               log onto the website. Disabling or removing cookies may require you to manually log on each time you wish
               to visit that website.</p>
         </div>

         <div class="one3d-privacy-popup-para-row">
            <p><b>Why we collect your information and how we use your information</b></p>
            <p>FCAA collects and uses your Personal Information to provide information relating to our products and
               services that is relevant to your interests. We also collect your Personal Information to:</p>
            <ul>
               <li>respond to your requests for information relating to sales, quotes, our products, brochures, test
                  drives and services offered; </li>
               <li>respond to feedback, complaints or comments, whether made by electronic means, telephone or in
                  person;</li>
               <li>supply products and services to you; </li>
               <li>allow you to purchase a product online via one of our Websites or Applications and process and
                  collect payment and deal with your account when you purchase products or services from us or our
                  dealers; </li>
               <li>communicate with our dealers to organise and allow you to test drive our cars or get a quote;</li>
               <li>to pass on enquiries or complaints made by you regarding our products, sales or services to a dealer
                  or a related party of FCAA who can assist with your enquiry or complaint; </li>
               <li>purchase goods and services from you; </li>
               <li>manage vehicle warranties; </li>
               <li>product registration and support; </li>
               <li>keep track of repairs to your vehicle; </li>
               <li>effect product recalls; </li>
               <li>provide after sale customer support such as issue service reminders and roadside assistance; </li>
               <li>conduct customer surveys and improve the quality of our service by contacting you to determine your
                  level of customer satisfaction; </li>
               <li>provide dealer support; </li>
               <li>notify you periodically about important things like an update to an Application or our terms and
                  conditions; </li>
               <li>undertake marketing and promotional activities; </li>
               <li>provide you with direct marketing to inform you of special offers and promotions that we think may be
                  of interest to you subject to obtaining your prior consent or being satisfied you would reasonably
                  expect to receive such direct marketing materials (as further detailed below under “DIRECT
                  MARKETING”); </li>
               <li>conduct market research and product development; </li>
               <li>contact you in the event of a security breach; </li>
               <li>meet our internal reporting requirements to global affiliates of FCAA in relation to statistics on
                  sales, warranties, repairs and marketing; </li>
               <li>process employment applications; </li>
               <li>report to and evaluate dealers; </li>
               <li>engage contractors;</li>
               <li>meet our legal and regulatory responsibilities and for fraud prevention purposes such as verifying
                  your identity;</li>
               <li>allow you to benefit from combining your location data with location based functionality in our
                  Website and Applications, for example to locate your closest dealer or get a quote locally; and</li>
               <li>contact you by email, phone, SMS or MMS or in any other lawful manner for the purposes set out above.
               </li>
            </ul>
            <p>FCAA does not collect and process any Personal Information unless the information is considered necessary
               for the effective functioning or activities of our business. Because most of the Personal Information we
               receive about you is collected directly from you or you have given to a dealer who has provided your
               Personal Information to us, you will normally be aware of the purpose of its collection. However, in the
               event FCAA receives Personal Information about you from a third party other than a dealer, we will inform
               you as soon as practicable from whom FCAA received your Personal Information from. </p>
            <p>Generally, FCAA only processes Personal Information for the purposes for which it was originally
               collected being the primary purposes stated above, unless required or authorised by or under law or if
               the individual concerned has consented to another intended use.</p>
         </div>

         <div class="one3d-privacy-popup-para-row">
            <p><b>Direct Marketing</b></p>
            <p>FCAA will only use your Personal Information such as an address, email address and/or phone number for
               the purpose of direct marketing where we have obtained your consent to do so, or in circumstances where
               you would reasonably expect your Personal Information would be used or disclosed for this purpose. Direct
               marketing activities FCAA and our related bodies corporate may conduct include contacting you by way of
               phone calls, mail, email, SMS text messages, mobile message services MMS or instant messaging.</p>
            <p>Where you have provided consent or would reasonably expect us to use your Personal Information for direct
               marketing, we may disclose Personal Information to third parties to allow them to direct market our
               products and services to you in the ways described above. The types of third parties that may contact you
               with direct marketing are set out below in Other Information Uses and Disclosure to Third Parties. There
               are also times when we join with dealers and other business associates of FCAA and may undertake joint
               marketing of our respective products and services to you.</p>
            <p>Your consent to receive direct marketing communications in the above ways will be deemed if you do not
               opt out when we offer you the opportunity to do so, and will remain current for an indefinite period of
               time unless and until you advise us otherwise. You can opt-out of receiving direct marketing at any time
               (see below).</p>
            <p>You can let us know at any time if you do not want the personal information we hold about you to be used
               or disclosed for any of the above purposes, or if you do not wish to be contacted in any of the above
               ways, by sending an email to: marketingau&#64;fcagroup.com , by phone by calling 03 8698 0200 or by mail
               to Direct Marketing Manager, FCA Australia Pty Ltd, 437 Plummer Street, Port Melbourne, Vic, 3207.</p>
         </div>

         <div class="one3d-privacy-popup-para-row">
            <p><b>Other information uses and disclosures to third parties</b></p>
            <p>FCAA does not use or pass onto others any Personal Information without the consent of the individual(s)
               concerned other than for the primary purpose of collecting the Personal Information or a reasonably
               related secondary purpose or as disclosed in this Privacy Policy or as required by law.</p>
            <p>FCAA's third party service providers may occasionally have access to the Personal Information held by
               FCAA under conditions of confidentiality.</p>
         </div>

         <div class="one3d-privacy-popup-para-row">
            <p>Our third party service providers are only authorised to use the information for the purpose for which we
               supply the information. Examples of the types of third parties we may need to disclose information to in
               the course of providing a product or service are:</p>
            <ul>
               <li>related bodies corporate of FCAA;</li>
               <li>FCAA’s authorised dealers; </li>
               <li>FCAA partners or their respective related bodies corporate;</li>
               <li>employees and contractors; </li>
               <li>parts suppliers; </li>
               <li>web hosting, data housing providers and other IT suppliers; </li>
               <li>insurers, lawyers, financiers and other professional advisers; </li>
               <li>service providers engaged by FCAA to provide a particular service on FCAA's behalf such as:</li>
               <li>printers of our marketing material; </li>
               <li>mailing houses to bulk mail marketing and promotional material,</li>
               <li>agencies that deal with product recalls and send information to affected customers; and</li>
               <li>marketing and research agencies that assist us with promotions or competitions, market research and
                  trend analysis; </li>
               <li>entities that provide roadside assistance to the purchasers of our vehicles and membership to
                  autoclubs; </li>
               <li>entities that process credit card payments; </li>
               <li>vehicle licensing authorities; </li>
               <li>the Australian Taxation Office or state revenue offices. </li>
               <li>a Court or to a third party under a subpoena issued by a Court; </li>
               <li>a regulatory authority; </li>
               <li>third parties for law enforcement purposes. </li>
            </ul>
         </div>

         <div class="one3d-privacy-popup-para-row">
            <p>FCAA may be required to disclose personal consent without consent of the individual where the law
               requires us to make the disclosure to bodies such as: </p>
            <ul>
               <li>the Australian Tax Office;</li>
               <li>a Court or to a third party under a subpoena issued by a Court;</li>
               <li>a regulatory authority.</li>
            </ul>
         </div>

         <div class="one3d-privacy-popup-para-row">
            <p>FCAA may use information relating to your visit to one of our Websites or Applications, or information
               you provide to us, for market research purposes in order to continually improve the products and services
               that FCAA delivers to you.</p>
            <p>On occasions, FCAA may form relationships with other organisations. FCAA may, with your prior consent,
               disclose your Personal Information to these organisations so that they may offer you special offers or
               competitions, relevant to your preferences. FCAA only deals with parties that demonstrate the same level
               of commitment to your privacy as FCAA does, and can ensure compliance with the Privacy Act.</p>
            <p>Certain promotions may be run by a FCAA service provider or vendor or co-branded with one of our partners
               or run on a third party site like Facebook. In these instances the collection of your Personal
               Information may occur directly by the service provider or vendor or a third-party partner on their
               website. The promotion will state the policies governing the collection of such information if they
               should differ from this Privacy Policy.</p>
            <p>Vendors and suppliers engaged by FCAA may have their use of your Personal Information limited by this
               Privacy Policy, contractual restrictions, or applicable law. However, if a particular Website or
               Application is co-branded or developed by a third party, it is possible that another party's Privacy
               Policy will govern the treatment of information on that Website or Application. FCAA (through its vendors
               or suppliers) may limit the acceptance of orders to particular jurisdictions and as permitted by
               applicable law.</p>
            <p>FCAA may sometimes permit our authorized service providers to have access to aggregate statistics about
               our customers, sales, traffic patterns, and related Website or Application information. These transfers
               of aggregate statistics do not involve Personal Information.</p>
            <p>FCAA offers a variety of services and functions through its Websites and Applications. Personal
               Information that is collected through a Website or Application may be used and/or disclosed to third
               parties in order to enable us to provide functionality or services to you. For example, some FCAA
               Websites and Applications allow you to interface with third party websites or applications. To facilitate
               that connection, we may use your Personal Information and/or disclose your Personal Information to third
               parties. When we provide location based services enabled through a third party, we may share data with
               those services in order to provide the related location based service or functionality.</p>
         </div>

         <div class="one3d-privacy-popup-para-row">
            <p><b>Mergers, acquisitions and insolvency</b></p>
            <p>If FCAA should ever file for bankruptcy or in the unlikely event that FCAA reorganizes or sells a part or
               the whole of its business or merges with another entity, its records of Personal Information may be
               transferred to a prospective purchaser, the actual purchaser, an entity a party to the merger or released
               to a liquidator. The information will remain subject to the Privacy Act and any other applicable laws and
               until further notified, will remain subject to FCAA's Privacy Policy.</p>
         </div>

         <div class="one3d-privacy-popup-para-row">
            <p><b>Transfer of Information Overseas</b></p>
            <p>FCAA, as part of the FCAG, has internal reporting requirements to other FCAG entities. Other FCAG
               entities may also provide a range of technology, operational (such as database storage services) and
               customer service functions on FCAA's behalf which may involve the transfer of your Personal Information
               to other FCAG entities located overseas. If you are a contractor, your personnel records, which may
               contain Sensitive Information may be sent overseas to other FCAG entities and/or FCAG database storage
               services.</p>
            <p>Some of our third party service providers to whom we disclose Personal Information to may also be located
               outside Australia The countries we may send your information to include: Italy, Singapore, China, United
               States and India.</p>
            <p>If information has to be disclosed overseas, the overseas recipient may not be subject to privacy
               obligations or to any principles similar to the APPs.</p>
            <p>An overseas recipient may also be subject to a foreign law which could compel disclosure of personal
               information to a third party, for example, an overseas government or regulatory authority.</p>
            <p>If you consent to the disclosure in circumstances where we have informed you that we will not take any
               steps to ensure that the overseas recipient deals with your Personal Information in accordance with the
               APPs the overseas recipient handles the information in breach of the APPs you will not be able to seek
               redress under the Privacy Act, may not be able to seek redress in the overseas jurisdiction and we will
               not be accountable under the Privacy Act.</p>
         </div>

         <div class="one3d-privacy-popup-para-row">
            <p><b>Accuracy of Information</b></p>
            <p>FCAA takes all reasonable steps to ensure that Personal Information is accurate, up to date, complete,
               relevant and is not misleading. To assist us in making sure your Personal Information is accurate, up to
               date and complete, we may contact you from time to time to ask you to advise us of any changes to your
               Personal Information. If you discover any Personal Information we hold about you is incorrect, please
               contact us immediately and we will correct it. The contact details to correct Personal Information should
               be directed to the Chief Security Officer of FCAA whose details are set out under Access to your Personal
               Information and Further Questions.</p>
            <p>If after receipt of your request to correct information we refuse to do so, you may request we associate
               the information with a statement that the information is incorrect, out of date, incomplete, irrelevant
               or misleading. If we refuse to correct your information we will provide you with reasons for the refusal
               and the mechanisms available to you to complain about the refusal.</p>
         </div>

         <div class="one3d-privacy-popup-para-row">
            <p><b>Security of Information</b></p>
            <p>FCAA takes all reasonable steps to ensure that Personal Information is kept safe from misuse,
               interference, loss and unauthorised access, modification and disclosure. The electronic database that
               holds the information is designed to restrict access to unauthorised persons.</p>
            <p>No data transmissions over the Internet can be guaranteed to be 100% secure. Consequently, FCAA cannot
               ensure or warrant the security of any information you transmit to FCAA and you do so at your own risk.
               Once FCAA receives your transmission, FCAA makes reasonable efforts to ensure security on our systems.
               FCAA uses secure server software (SSL) and firewalls to protect your information from unauthorised
               access, disclosure, alteration, or destruction. However, please note that this is not a guarantee that
               such information may not be accessed, disclosed, altered, or destroyed by breach of such firewalls and
               secure server software. If FCAA learns of a security system's breach, FCAA may attempt to notify you
               electronically so that you can take appropriate protective steps. By using one of our Websites or
               Application, you agree that FCAA can communicate with you electronically regarding security, privacy, and
               administrative issues relating to your use of the Website or Application. FCAA may send an email to you
               at the email address you have provided to FCAA if a security breach occurs. If you become aware of any
               breach of security involving your Personal Information, please contact us immediately.</p>
            <p>Except to the extent liability cannot be excluded under statute, we exclude all liability (including in
               negligence) for the consequences of any unauthorised access to, disclosure of, misuse of or loss or
               corruption of your Personal Information. Nothing in this Privacy Policy restricts, excludes or modifies
               or purports to restrict, exclude or modify any statutory consumer rights under any applicable law
               including the Competition and Consumer Act 2010 (Cth).</p>
            <p>FCAA takes all reasonable steps to destroy or permanently de-identify Personal Information that is no
               longer needed for a permitted purpose and it is not required to be retained by law.</p>
         </div>

         <div class="one3d-privacy-popup-para-row">
            <p><b>Public areas</b></p>
            <p>Any information disclosed in public areas of a FCAA Website or Application or other website (Facebook,
               YouTube, Twitter, etc.) will become public information. FCAA cannot control the use of information
               disclosed in public forums, such as social media forums, platforms, bulletin boards, blogs, wikis, chat
               rooms, and networking functions of mobile-device applications. You should exercise caution when
               disclosing information in these public areas, especially your location-data, and be careful how you
               disclose your Personal Information. Content posted in public areas of FCAA Websites or Applications,
               including advice and opinions, represent the views and is the responsibility of those who post the
               content. FCAA does not necessarily endorse, support, verify, or agree with the content posted and
               reserves the right to remove comments that FCAA considers to be offensive, derogatory or otherwise
               inappropriate. If you have any questions or comments about any content on a FCAA Website or Application
               please send us an email: marketingau&#64;fcagroup.com</p>
         </div>

         <div class="one3d-privacy-popup-para-row">
            <p><b>Children</b></p>
            <p>FCAG Websites and Applications are not directed at children. If you are under 18 or otherwise would be
               required to have parent or guardian consent to share information with FCAA, you should not send any
               information about yourself to FCAA. If a person under 18 submits information through any part of a FCAG
               Website or Application, and FCAA learns the person submitting the information is a child, FCAA will
               attempt to delete this information as soon as possible. Because FCAA does not knowingly collect any
               Personal Information from persons under 18, FCAA does not knowingly use or disclose such information to
               third parties.</p>
         </div>

         <div class="one3d-privacy-popup-para-row">
            <p><b>Access to your personal information</b></p>
            <p>You may request access to Personal Information FCAA holds about you by contacting our Chief Security
               Officer in writing at the address below. For security reasons, we require that requests for Personal
               Information are provided in writing and specify the Personal Information you would like to access.</p>
            <p>Our Chief Security Officer will consider the request and advise you of their decision in writing within a
               reasonable time from receipt of the request.</p>
            <p>Where we hold Personal Information you are entitled to access, we may charge you a fee for accessing your
               Personal Information which will reflect our reasonable costs of retrieving and supplying the information
               to you.</p>
            <p>We may refuse access to your Personal Information in accordance with the Privacy Act, including where the
               Personal Information relates to anticipated legal proceedings, the request is frivolous or vexatious or
               giving access would have an unreasonable impact on the privacy of other individuals. If we refuse to
               provide access, we will give written reasons for the refusal together with the mechanisms available to
               complain about the refusal.</p>
         </div>

         <div class="one3d-privacy-popup-para-row">
            <p><b>Further questions and complaints</b></p>
            <p>At all times, FCAA strives to ensure your Personal Information is treated confidentially, and in
               accordance with the Privacy Act. If you have any questions about this Privacy Policy or believe we have
               at any time failed to keep one of our commitments to you to handle your Personal Information in the
               manner required by the Privacy Act, then we ask that you provide such complaint or question to us in
               writing. Please provide as much detail as possible in relation to your question, concern or complaint to
               help us assist you.</p>
         </div>

         <div class="one3d-privacy-popup-para-row">
            <p><b>All such enquiries should be directed to:</b></p>
            <p>Mail:</p>
            <p>Chief Security Officer</p>
            <p>FCA Australia Pty Ltd</p>
            <p>437 Plummer Street, Port Melbourne, VIC 3207, Australia</p>
            <p>Australia PO Box 23267, Dockland 3008</p>
         </div>

         <div class="one3d-privacy-popup-para-row">
            <p>Email:</p>
            <p><a href="mailto:CSOAU&#64;fcagroup.com">CSOAU&#64;fcagroup.com</a></p>
            <p>Our Chief Security Officer will consider the complaint and advise you of their decision in writing within
               a reasonable time from receipt of the complaint.</p>
            <p>If we do not agree with your complaint, we will provide you with reasons. If our Chief Security Officer
               decides that there has been a breach of the APPs, s/he will endeavour to ensure that the breach is
               rectified within 30 days from the date of the decision and will update you in writing. If you are still
               not satisfied after lodging a complaint with us and given us a reasonable time to respond, then we
               suggest that you contact the Office of the Australian Information Commissioner by:</p>
         </div>

         <div class="one3d-privacy-popup-para-row">
            <p>Phone: 1300 363 992 (local call cost, but calls from mobile and pay phones may incur higher charges). If
               calling from overseas (including Norfolk Island): +61 2 9284 9749
               <br>TTY: 1800 620 241 (this number is dedicated to the hearing impaired only, no voice calls.)
               <br>TIS: Translating and Interpreting Service: 131 450 (If you don’t speak English or English is your
               second language and you need assistance and ask for the Office of the Australian Information
               Commissioner)
            </p>
         </div>

         <div class="one3d-privacy-popup-para-row">
            <p>Post: GPO Box 2999 Canberra ACT 2601 <br>
               Fax: +61 2 9284 9666<br>
               Email: <a href="mailto:enquiries&#64;oaic.gov.au">enquiries&#64;oaic.gov.au</a></p>
         </div>

      </div>

   </div>
</div>